import dayjs from 'dayjs'

export const getFormattedDate = (): string[] => {
  const now = new Date() // 获取当前时间

  const year = now.getFullYear().toString() // 获取年份
  const month = (now.getMonth() + 1).toString().padStart(2, '0') // 获取月份，补0
  const day = now.getDate().toString().padStart(2, '0') // 获取日期，补0

  return [year, month, day]
}
export const getDateBeforeDays = (days: number): string[] => {
  const now = new Date() // 获取当前时间
  now.setDate(now.getDate() - days) // 设置为days天前的日期
  const year = now.getFullYear().toString() // 获取年份
  const month = (now.getMonth() + 1).toString().padStart(2, '0') // 补0处理月份
  const day = now.getDate().toString().padStart(2, '0') // 补0处理日期
  return [year, month, day]
}
/**
 * 获取前一天的日期
 * @param date 当前日期对象
 * @returns 前一天的日期对象
 */
export function getPreviousDate(date: Date): string {
  const prevDate = new Date(date)
  prevDate.setDate(date.getDate() - 1) // 设置为前一天
  return dayjs(prevDate).format('YYYY-MM-DD')
}
// 获取六个月前的日期
export function getSixMonthsAgoDate(): Date {
  // 创建当前日期对象
  const currentDate = new Date()
  // 获取当前月份
  const currentMonth = currentDate.getMonth()
  // 计算六个月前的月份
  const sixMonthsAgoMonth = currentMonth - 6
  // 设置日期为六个月前
  currentDate.setMonth(sixMonthsAgoMonth)
  return currentDate
}
export function isDateDifferenceOver31Days(date1: Date, date2: Date): boolean {
  // 获取两个日期的时间戳
  const timestamp1 = date1.getTime()
  const timestamp2 = date2.getTime()

  // 计算两个时间戳的差值（毫秒）
  const timeDifference = Math.abs(timestamp1 - timestamp2)

  // 将毫秒差值转换为天数
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24)

  // 判断天数差值是否超过 31
  return daysDifference > 31
}
export const getFirstTimeFormat = (value: string) => {
  return (
    dayjs(value).format('HH:mm:ss') + '  ' + dayjs(value).format('DD-MM-YYYY')
  )
}
